<div class="fixed bottom-20 right-0">
    <div [ngClass]="isLogged ? 'comment__login' : 'comment__logout'" (click)="openModal()" class="comment ml-auto">
        <img src="./assets/svg/comment.svg" />
    </div>
</div>

<ng-container *ngIf="modalContactForm">
    <div class="background"></div>
    <div class="fixed max-w-[1440px] container top-4 z-[502]">
        <div class="quiet ml-auto">
            <span class="material-symbols-rounded" (click)="closeModal()">
                close
            </span>
        </div>
    </div>
    <iframe class="iframe-container" [src]="environment.avlaFormURL | sanitize"></iframe>
</ng-container>